import {
    BasisType,
    IPossibleBasisType,
    TAVBasisTypes,
    BasisTypeName,
    CustomerType,
} from '@raskrask-dk/bookingflow-state-machine'
import MassageIcon from '../assets/icons/basistypes/circles/svg/Massage.svg'
import TrainingIcon from '../assets/icons/basistypes/circles/svg/Training.svg'
import YogaIcon from '../assets/icons/basistypes/circles/svg/Yoga.svg'

const icons: Record<string, any> = {
    Massage: MassageIcon,
    Training: TrainingIcon,
    Yoga: YogaIcon,
}

type BasisTypeBFConstructor = {
    id: number
    name: BasisTypeName
    disabled: boolean
    icon: string
}

class BasisTypeBF extends BasisType {
    icon: string
    disabled: boolean

    constructor({ id, name, disabled, icon }: BasisTypeBFConstructor) {
        super(name, id)
        this.icon = icon
        this.disabled = disabled
    }

    static fromIPossibleBasisTypes(
        possibleBasisTypes: IPossibleBasisType[],
        availableBasisTypes: TAVBasisTypes
    ): BasisTypeBF[] {
        const isDisabled = (basisType: IPossibleBasisType) => {
            const id = `${basisType.basisTypeId}_${basisType.medium}_${basisType.customerType}`
            return !availableBasisTypes.junctionAVBasisTypes.byId[id].Available
        }

        return possibleBasisTypes.map((basisType) =>
            BasisTypeBF.fromIPossibleBasisType(basisType, isDisabled(basisType))
        )
    }

    static fromDTO({
        id,
        name,
        available,
        customerTypes,
    }: {
        id: BasisType['id']
        name: BasisType['name']
        available: boolean
        customerTypes: CustomerType[]
    }): BasisTypeBF {
        const b = new BasisTypeBF({
            id: id,
            name: name as BasisTypeName,
            disabled: !available,
            icon: icons[name],
        })
        customerTypes.forEach((ct) => b.addBookableBy(ct))
        return b
    }
    static fromIPossibleBasisType(
        basisType: IPossibleBasisType,
        disabled: boolean
    ): BasisTypeBF {
        const { basisTypeId: id, basisTypeName: name } = basisType
        return new BasisTypeBF({
            id: id,
            name: name as BasisTypeName,
            disabled: disabled,
            icon: icons[name],
        })
    }

    public get t(): { name: string } {
        return {
            name: `common:basistypes.${this.id}.name`,
        }
    }
}
export default BasisTypeBF
